export function useMaterialSceneLightmaps(payload, viewport) {
/*
    //floor_exterior--------------------------------------------------------------------

    let materialUpdateObject = {};
    materialUpdateObject.name = "floor_exterior";
    materialUpdateObject.textures = {};

    materialUpdateObject.textures.lightmapTexture = {};
    materialUpdateObject.textures.lightmapTexture.key ="room_2_floor_and_walls_1";
    materialUpdateObject.textures.lightmapTexture.textureProperties = {};
    materialUpdateObject.textures.lightmapTexture.textureProperties.vScale = -1;
    materialUpdateObject.textures.lightmapTexture.textureProperties.coordinatesIndex = 1;
    materialUpdateObject.textures.lightmapTexture.textureProperties.level = 1;  
    
    materialUpdateObject.props = {};   
    materialUpdateObject.props.useLightmapAsShadowmap = true;

    viewport.updateMaterial(materialUpdateObject)

    //floor_exterior--------------------------------------------------------------------

    materialUpdateObject = {};
    materialUpdateObject.name = "shower_floor";
    materialUpdateObject.textures = {};

    materialUpdateObject.textures.lightmapTexture = {};
    materialUpdateObject.textures.lightmapTexture.key ="sentrel_ao_2";
    materialUpdateObject.textures.lightmapTexture.textureProperties = {};
    materialUpdateObject.textures.lightmapTexture.textureProperties.vScale = -1;
    materialUpdateObject.textures.lightmapTexture.textureProperties.coordinatesIndex = 1;
    materialUpdateObject.textures.lightmapTexture.textureProperties.level = 1;   

    materialUpdateObject.props = {};   
    materialUpdateObject.props.useLightmapAsShadowmap = true;

    viewport.updateMaterial(materialUpdateObject)

    //shower_floor_threshold--------------------------------------------------------------------

    materialUpdateObject = {};
    materialUpdateObject.name = "shower_floor_threshold";
    materialUpdateObject.textures = {};

    materialUpdateObject.textures.lightmapTexture = {};
    materialUpdateObject.textures.lightmapTexture.key ="sentrel_ao_2";
    materialUpdateObject.textures.lightmapTexture.textureProperties = {};
    materialUpdateObject.textures.lightmapTexture.textureProperties.vScale = -1;
    materialUpdateObject.textures.lightmapTexture.textureProperties.coordinatesIndex = 1;
    materialUpdateObject.textures.lightmapTexture.textureProperties.level = 1;   

    materialUpdateObject.props = {};   
    materialUpdateObject.props.useLightmapAsShadowmap = true;

    viewport.updateMaterial(materialUpdateObject)

    //wall_interior--------------------------------------------------------------------

    materialUpdateObject = {};
    materialUpdateObject.name = "wall_interior";
    materialUpdateObject.textures = {};

    materialUpdateObject.textures.lightmapTexture = {};
    materialUpdateObject.textures.lightmapTexture.key ="sentrel_ao_2";
    materialUpdateObject.textures.lightmapTexture.textureProperties = {};
    materialUpdateObject.textures.lightmapTexture.textureProperties.vScale = -1;
    materialUpdateObject.textures.lightmapTexture.textureProperties.coordinatesIndex = 1;
    materialUpdateObject.textures.lightmapTexture.textureProperties.level = 1;   

    materialUpdateObject.props = {};   
    materialUpdateObject.props.useLightmapAsShadowmap = true;

    viewport.updateMaterial(materialUpdateObject)

     //wall_interior_mould--------------------------------------------------------------------

     materialUpdateObject = {};
     materialUpdateObject.name = "wall_interior_mould";
     materialUpdateObject.textures = {};
 
     materialUpdateObject.textures.lightmapTexture = {};
     materialUpdateObject.textures.lightmapTexture.key ="sentrel_ao_2";
     materialUpdateObject.textures.lightmapTexture.textureProperties = {};
     materialUpdateObject.textures.lightmapTexture.textureProperties.vScale = -1;
     materialUpdateObject.textures.lightmapTexture.textureProperties.coordinatesIndex = 1;
     materialUpdateObject.textures.lightmapTexture.textureProperties.level = 1;   
 
     materialUpdateObject.props = {};   
     materialUpdateObject.props.useLightmapAsShadowmap = true;
 
     viewport.updateMaterial(materialUpdateObject)

      //wall_exterior--------------------------------------------------------------------

      materialUpdateObject = {};
      materialUpdateObject.name = "wall_exterior";
      materialUpdateObject.textures = {};
  
      materialUpdateObject.textures.lightmapTexture = {};
      materialUpdateObject.textures.lightmapTexture.key ="wall_exterior_ao";
      materialUpdateObject.textures.lightmapTexture.textureProperties = {};
      materialUpdateObject.textures.lightmapTexture.textureProperties.vScale = -1;
      //materialUpdateObject.textures.lightmapTexture.textureProperties.coordinatesIndex = 1;
     // materialUpdateObject.textures.lightmapTexture.textureProperties.level = 1;   
  
      materialUpdateObject.props = {};   
      materialUpdateObject.props.useLightmapAsShadowmap = true;
  
      viewport.updateMaterial(materialUpdateObject)*/
   let materialUpdateObject = {};
     materialUpdateObject.name = "glass_1";

     materialUpdateObject.props = {};   
     materialUpdateObject.props.alpha = 0.11;
     materialUpdateObject.colors = {};
     materialUpdateObject.colors.albedoColor ="glass_color_1";

     materialUpdateObject.textures = {};
 
     materialUpdateObject.textures.metallicTexture = {};
     materialUpdateObject.textures.metallicTexture.key ="glass_clear_rough";
     materialUpdateObject.textures.metallicTexture.textureProperties = {};
     materialUpdateObject.textures.metallicTexture.textureProperties.vScale = -1;
 
     materialUpdateObject.textures.bumpTexture = {};
     materialUpdateObject.textures.bumpTexture.key ="glass_clear_normal";
     materialUpdateObject.textures.bumpTexture.textureProperties = {};
     materialUpdateObject.textures.bumpTexture.textureProperties.vScale = -1;
 
  
 
     viewport.updateMaterial(materialUpdateObject)


     //

      materialUpdateObject = {};
     materialUpdateObject.name = "props";

     materialUpdateObject.props = {};  
    
     materialUpdateObject.colors = {};
     materialUpdateObject.colors.emissiveColor ="emmission_1";
     viewport.updateMaterial(materialUpdateObject)

       //

       materialUpdateObject = {};
     materialUpdateObject.name = "roof";

     materialUpdateObject.props = {};  
    
     materialUpdateObject.colors = {};
     materialUpdateObject.colors.albedoColor ="e6e6e6";
     materialUpdateObject.colors.emissiveColor ="emmission_1";
     viewport.updateMaterial(materialUpdateObject)

       //

      materialUpdateObject = {};
     materialUpdateObject.name = "mirror";

     materialUpdateObject.props = {};  
    
     materialUpdateObject.colors = {};
     materialUpdateObject.colors.emissiveColor ="emmission_2";
     viewport.updateMaterial(materialUpdateObject)

     //

        materialUpdateObject = {};
     materialUpdateObject.name = "curtain";

     materialUpdateObject.props = {};  
    
     materialUpdateObject.colors = {};
     materialUpdateObject.colors.albedoColor ="c8c8c8";  
     materialUpdateObject.props.roughness = 0.2;
     viewport.updateMaterial(materialUpdateObject)


//
        materialUpdateObject = {};
     materialUpdateObject.name = "porcaline_1";

     materialUpdateObject.props = {};  
    
     materialUpdateObject.colors = {};
     materialUpdateObject.colors.albedoColor ="c8c8c8";
     viewport.updateMaterial(materialUpdateObject)
//

     /*   materialUpdateObject = {};
     materialUpdateObject.name = "wall_exterior";

    materialUpdateObject.props = {};  
     materialUpdateObject.props.roughness = 1;
     materialUpdateObject.props.indexOfRefraction = 3;*/
    
  
     viewport.updateMaterial(materialUpdateObject)


  

}